import { RecipesPhotosStorage, recipeCoverPhotoName } from 'services/firebase';

import urlMimeType from 'utils/urlMimeType';
import urlToFile from 'utils/urlToFile';

const uploadCoverPhoto = async (recipeID, url) => {
  if (!recipeID) throw new Error('recipeID cannot be empty');
  if (!url) throw new Error('url cannot be empty');

  const mimeType = urlMimeType(url);
  const fileName = recipeCoverPhotoName(mimeType);
  const coverPhotoFile = await urlToFile(url, fileName, mimeType);
  const recipesPhotosStorage = RecipesPhotosStorage(recipeID);

  const snapshot = await recipesPhotosStorage
    .child(fileName)
    .put(coverPhotoFile, {
      cacheControl: 'public, max-age=15552000',
    });

  return await snapshot.ref.getDownloadURL();
};

export default uploadCoverPhoto;
